import Link from 'next/link'
import { ArrowLeftIcon } from '@heroicons/react/24/outline'
import { cn } from 'cn'
import useTheme from 'lib/theme/useTheme'

type Props = {
  label?: string
} & ({ href: string; onClick?: never } | { onClick: () => void; href?: never })

export default function BackButton({ href, onClick, label = 'Back' }: Props) {
  const { theme, isOrganizer } = useTheme()
  const themedBackground = isOrganizer && theme.page.themedBackground

  const innerClasses = cn(
    'max-w-max flex flex-row group items-center px-2 py-1 md:px-4 md:py-2 rounded-md transition-all duration-200',
    {
      'bg-white/10': themedBackground,
      'bg-gray-100': !themedBackground
    }
  )

  const iconClasses = cn('w-4 h-4 mr-2', {
    'text-white/60 group-hover:text-white/80': themedBackground,
    'text-gray-400 group-hover:text-gray-500': !themedBackground
  })

  const textClasses = cn('text-sm', {
    'text-white/60 group-hover:text-white/80': themedBackground,
    'text-gray-500 group-hover:text-gray-600': !themedBackground
  })

  const content = (
    <>
      <ArrowLeftIcon className={iconClasses} />
      <p className={textClasses}>{label}</p>
    </>
  )

  if (href) {
    return (
      <Link className="inline-block" href={href}>
        <div className={innerClasses}>{content}</div>
      </Link>
    )
  }

  return (
    <button type="button" onClick={onClick} className={innerClasses}>
      {content}
    </button>
  )
}
